import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { CNConsultation } from 'src/app/models/cnconsultation';

@ManageType('ContactContentRxComponent')
@Component({
  selector: 'app-contact-content-rx',
  templateUrl: './contact-content-rx.component.html',
  styleUrls: ['./contact-content-rx.component.scss']
})
export class ContactContentRxComponent implements OnInit, ContactContainer {

  private contentContact: CNConsultation;

  constructor() {
  }

  ngOnInit(): void {
  }

  /**
   * ContactContainer interface
   */

   @Input() set contact(theContact: CNConsultation) {
    this.contentContact = theContact;
    console.log('contact', this.contentContact);
  }

  get contact(): CNConsultation {
    return this.contentContact;
  }
}
